// ======================================================================
// File Name       : CourseEditUserSearchList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup, Col, Row, Button, Table, FormControl } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../components/TableHead';
import { getItemBoxName, parseDateForDetail, displayUserAuthority, WRONG_ATTENDING_DATE_TXT } from '../../utils/index';
import { DEFAULT_DATE_FORMAT, DORMANT_STATE } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import DateTimeWithValidate from '../../components/DateTimeWithValidate';
import DateTimeMinMax from '../../components/DateTimeMinMax';
import SelectBox from '../../components/SelectBox';
import Pagination from '../../components/Pagination';
import { USER_TYPE } from '../../constants/UserConstants';

class CourseEditUserSearchList extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextProps.searchUserResult === this.props.searchUserResult &&
    nextProps.checkedUser === this.props.checkedUser &&
    nextProps.editingUser === this.props.editingUser &&
    nextProps.authority === this.props.authority &&
    nextProps.isShowMessageMaxRecord === this.props.isShowMessageMaxRecord;
    return !shouldNotUpdate;
  }

  render() {
    const {
      searchUserResult,
      checkedUser,
      editingUser,
      authority,
      isShowMessageMaxRecord,
    } = this.props;
    this.refsToValidate = [];

    return (
      <div>
        <Row>
          <Col sm={12} className="margin-top-10">
            <Col sm={2} className="padding-left-right-clear">
              <Button variant="default" onClick={this.props.handleAddRemoveAllUser}>全選択/解除</Button>
            </Col>
            <Col sm={10} className="d-flex justify-content-end">
              <Pagination
                className="margin-clear"
                startPosition={searchUserResult.startPosition}
                recordNum={searchUserResult.recordNum}
                handlePageSelect={this.props.handlePageChange}
              />
            </Col>
          </Col>
        </Row>
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-1" />
              <th>ロール/ユーザー種別</th>
              <th>ユーザー名</th>
              <th>グループ名</th>
              <th>ログインID</th>
            </tr>
          </thead>
          <tbody>
            {
              searchUserResult && searchUserResult.allSecernIds &&
              searchUserResult.allSecernIds.map((userSecernId, index) => {
                const user = searchUserResult.bySecernId[userSecernId];
                const checked = checkedUser.allSecernIds.indexOf(userSecernId) > -1;
                return (
                  <tr key={index} className={user.dormantState == DORMANT_STATE.INACTIVE ? 'inactive-class' : ''}>
                    <td>
                      <Form.Check
                        type='checkbox'
                        className="text-center margin-clear"
                        value={userSecernId}
                        checked={checked}
                        onChange={this.props.handleUserCheck}
                        disabled={!!editingUser[userSecernId]} />
                    </td>
                    <td>
                      {displayUserAuthority(user, authority)}
                    </td>
                    <td>
                      {user.userName}
                    </td>
                    <td>
                      {user.groupName}
                    </td>
                    <td>
                      {user.loginId}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>
        <Row>
          <Col sm={12} className="text-center">
            <Button
              variant="primary"
              className="btn-96"
              onClick={this.props.handleAddUserRelation}
              disabled={(!checkedUser || !checkedUser.allSecernIds || !checkedUser.allSecernIds.length)}
            >
              追加
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CourseEditUserSearchList;
